<template>
  <span class="campaign-badge py-1 px-3 text-nowrap" :style="style" :data-id="id">
    <font-awesome-icon icon="tag" />&nbsp;&nbsp;<span>{{ title }}</span>
  </span>
</template>

<script>
import { mapRoot } from '@src/mixins/root';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'CampaignBadge',
  props: {
    campaign: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapRoot([ 'company' ]),
    style() {
      const { siteBranding: { primaryColour, backgroundColour } = {} } = this.company || {};

      if (primaryColour && backgroundColour) {
        return {
          backgroundColor: primaryColour,
          color: backgroundColour
        };
      } else {
        return {
          backgroundColor: '#ffffff',
          color: '#000000'
        };
      }
    },
    id() {
      return this.campaign && this.campaign.id
        ? this.campaign.id
        : null;
    },
    title() {
      return this.campaign && this.campaign.title
        ? this.campaign.title
        : null;
    },
  },
  components: { FontAwesomeIcon },
};
</script>

<style lang="scss">
.campaign-badge {
  font-size: 13px;
  border-radius: 4px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/campaign/Badge.vue